export default class ProspectEnteteController {
	static $inject = [
		'$stateParams',
		'ProspectsCommunicationService',
		'ProspectsService',
		'notification',
		'CodeAutomatiqueService',
		'MassiaApplicationService',
		'PersonnesService',
		'RouterHistoryService'
	];

	constructor(
		$stateParams,
		ProspectsCommunicationService,
		ProspectsService,
		notification,
		CodeAutomatiqueService,
		MassiaApplicationService,
		PersonnesService,
		RouterHistoryService
	) {
		this.$stateParams = $stateParams;
		this.ProspectsCommunicationService = ProspectsCommunicationService;
		this.ProspectsService = ProspectsService;
		this.notification = notification;
		this.CodeAutomatiqueService = CodeAutomatiqueService;
		this.MassiaApplicationService = MassiaApplicationService;
		this.PersonnesService = PersonnesService;
		this.RouterHistory = RouterHistoryService;
	}

	async $onInit() {
		this.loading = false;
		this.codeLoading = false;
		this.isEditMode = false;
		this.unregisterReinit = this.ProspectsCommunicationService.registerReinit(() => this.initForm());
		this.prospect.entete.fromExternalForm = false;
		await this.initForm();
		await this.getCodeAuto();

		this.contacts = await this.PersonnesService.getContactWithoutSite();
		if (this.$stateParams.contactId) {
			this.prospect.entete.contactId = this.$stateParams.contactId;
		}
	}

	$onDestroy() {
		this.unregisterReinit();
	}

	async initForm() {
		if (this.$stateParams && this.$stateParams.id && !this.$stateParams.fromOffre) {
			this.isEditMode = true;
		} else {
			this.isEditMode = false;
		}
		await this.getSocietes();

		if (this.societes && this.societes.length > 0 && this.$stateParams.idSociete && this.$stateParams.idSociete !== 'undefined') {
			this.prospect.entete.societeId = this.$stateParams.idSociete;
		}
		await this.getPays();
	}

	async getCodeAuto() {
		try {
			this.prospect.entete.estCodeAuto = await this.ProspectsService.estCodeAuto();
			if (this.prospect.entete.estCodeAuto) {
				this.prospect.entete.afficheCode = await this.ProspectsService.afficheCode('prospects');
			} else {
				this.prospect.entete.afficheCode = true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		}
	}

	async getSocietes() {
		this.startLoading();
		try {
			const res = await this.ProspectsService.getSocietes();
			this.societes = res;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getPays() {
		this.startLoading();
		try {
			const res = await this.ProspectsService.getPays();
			this.paysListe = res.items;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async checkCodeUnicity(code) {
		if (!code) {
			this.prospect.entete.codeExists = null;
			return;
		}
		this.startCodeLoading();
		try {
			if (code.match(/^[a-zA-Z0-9_]*$/)) {
				this.prospect.entete.codeExists = await this.ProspectsService.codeExists(code);
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopCodeLoading();
		}
	}

	numberOnly() {
		if (isNaN(this.element.valeur)) {
			this.element.valeur = null;
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}

	saveCurrentInRouterHistory() {
		this.RouterHistory.prospect = this.prospect;
		this.prospect.entete.fromExternalForm = true;
	}
}
